export const en = {
  locale: 'en',
  messages: {
    lang: 'Language',
    feed: 'NEWS FEED',
    dashboard: 'Dashboard',
    profile: 'Profile',
    logout: 'Logout',
    add: 'Add',
    registerhere: 'Register Here',
    email: 'Email',
    password: 'Password',
    register: 'Register',
    loginpage: 'Login Page',
    fullname: 'Full Name',
    repeatpass: 'Repeat Password',
    loginTitle: 'Portail de gestion Tikeasy',
    loginSubtitle: 'Identification',
    partnerSpace: 'Partner Space ',
  },
};
